import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=cae30242&scoped=true&"
import script from "./TableData.vue?vue&type=script&lang=js&"
export * from "./TableData.vue?vue&type=script&lang=js&"
import style0 from "./TableData.vue?vue&type=style&index=0&id=cae30242&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae30242",
  null
  
)

export default component.exports